// Quiz Grossesse - Fichier JavaScript externe pour Shopify
(function() {
  if (!document.getElementById('quizContainer')) {
    return; // Pas de quiz grossesse sur cette page
  }

  console.log('🤰 Quiz grossesse détecté');

  const questions = [
    {
      id: 1,
      question: "Où en êtes-vous dans votre cycle ?",
      answers: [
        { text: "Moins de 10 jours après ovulation", value: 1 },
        { text: "10-14 jours après ovulation", value: 2 },
        { text: "Retard de règles (1-3 jours)", value: 4 },
        { text: "Retard de règles (4+ jours)", value: 5 },
        { text: "Je ne sais pas quand j'ai ovulé", value: 0 }
      ]
    },
    {
      id: 2,
      question: "Avez-vous observé des saignements ou pertes inhabituels ?",
      answers: [
        { text: "Oui, légers et rosés/marron (quelques heures à 2 jours)", value: 3 },
        { text: "Oui, flux normal rouge vif comme des règles", value: -2 },
        { text: "Pertes blanches crémeuses inhabituelles", value: 1 },
        { text: "Non, aucun saignement", value: 0 }
      ]
    },
    {
      id: 3,
      question: "Ressentez-vous des douleurs dans le bas-ventre ?",
      answers: [
        { text: "Oui, légères et d'un côté (tiraillements)", value: 2 },
        { text: "Oui, fortes comme des crampes de règles", value: 0 },
        { text: "Non, aucune douleur", value: 0 },
        { text: "Oui, mais c'est plutôt des ballonnements", value: 0 }
      ]
    },
    {
      id: 4,
      question: "Comment sont vos seins actuellement ?",
      answers: [
        { text: "Très sensibles + auréoles plus foncées", value: 2 },
        { text: "Légèrement sensibles (comme d'habitude avant règles)", value: 0 },
        { text: "Aucun changement notable", value: 0 }
      ]
    },
    {
      id: 5,
      question: "Niveau d'énergie et sensations générales ?",
      answers: [
        { text: "Fatigue intense inhabituelle", value: 1 },
        { text: "Nausées ou aversions alimentaires soudaines", value: 2 },
        { text: "Envie fréquente d'uriner", value: 1 },
        { text: "Aucun changement", value: 0 }
      ]
    },
    {
      id: 6,
      question: "Si vous prenez votre température basale :",
      answers: [
        { text: "Elle est restée haute 18+ jours après ovulation", value: 4 },
        { text: "Elle est haute mais moins de 18 jours", value: 1 },
        { text: "Elle a redescendu", value: -1 },
        { text: "Je ne prends pas ma température", value: 0 }
      ]
    },
    {
      id: 7,
      question: "Avez-vous déjà fait un test de grossesse ?",
      answers: [
        { text: "Oui, positif", value: 10 },
        { text: "Oui, négatif (fait il y a moins de 7 jours)", value: -1 },
        { text: "Oui, négatif (fait il y a 7+ jours)", value: 0 },
        { text: "Non, pas encore", value: 0 }
      ]
    }
  ];

  let currentQuestion = 0;
  let userAnswers = [];

  function displayQuestion(index) {
    const container = document.getElementById('quizContainer');
    if (!container) return;

    const q = questions[index];

    let answersHTML = q.answers.map((answer, i) => `
      <label data-answer-index="${i}" data-answer-value="${answer.value}" style="display: block; padding: 15px 20px; margin-bottom: 12px; border: 2px solid #e8dfe6; border-radius: 12px; cursor: pointer; transition: all 0.3s; background: white;">
        <input type="radio" name="q${index}" value="${answer.value}" style="margin-right: 12px; width: 18px; height: 18px; cursor: pointer;">
        <span style="color: #4a4a4a; font-size: 1.05em;">${answer.text}</span>
      </label>
    `).join('');

    container.innerHTML = `
      <div style="animation: fadeIn 0.4s ease;">
        <h3 style="color: #6b4e5c; font-size: 1.3em; margin: 0 0 20px 0; font-weight: 600;">${q.question}</h3>
        ${answersHTML}
      </div>
    `;

    // Attacher les événements en JS (plus robuste que des onclick/onmouseover inline)
    const labels = container.querySelectorAll('label');
    labels.forEach(function(label) {
      label.addEventListener('mouseover', function() {
        if (!this.querySelector('input').checked) {
          this.style.borderColor = '#c994b5';
          this.style.background = '#fef9fb';
        }
      });
      label.addEventListener('mouseout', function() {
        if (!this.querySelector('input').checked) {
          this.style.borderColor = '#e8dfe6';
          this.style.background = 'white';
        }
      });
      label.addEventListener('click', function() {
        const answerIndex = parseInt(this.dataset.answerIndex, 10);
        const answerValue = parseInt(this.dataset.answerValue, 10);
        selectAnswer(index, answerIndex, answerValue);
      });
    });

    // Pré-sélectionner la réponse si elle existe
    if (userAnswers[index] !== undefined) {
      const radio = container.querySelector(`input[value="${userAnswers[index]}"]`);
      if (radio) {
        radio.checked = true;
        radio.parentElement.style.borderColor = '#c994b5';
        radio.parentElement.style.background = '#fef9fb';
      }
    }

    updateProgress();
    updateButtons();
  }

  function selectAnswer(questionIndex, answerIndex, value) {
    userAnswers[questionIndex] = value;

    const container = document.getElementById('quizContainer');
    if (!container) return;

    const labels = container.querySelectorAll('label');
    labels.forEach(function(label, i) {
      if (i === answerIndex) {
        label.style.borderColor = '#c994b5';
        label.style.background = '#fef9fb';
        label.querySelector('input').checked = true;
      } else {
        label.style.borderColor = '#e8dfe6';
        label.style.background = 'white';
      }
    });
  }

  function updateProgress() {
    const percent = Math.round(((currentQuestion + 1) / questions.length) * 100);
    const progressBar = document.getElementById('progressBar');
    const progressText = document.getElementById('progressText');
    const progressPercent = document.getElementById('progressPercent');

    if (progressBar) progressBar.style.width = percent + '%';
    if (progressText) progressText.textContent = `Question ${currentQuestion + 1} / ${questions.length}`;
    if (progressPercent) progressPercent.textContent = percent + '%';
  }

  function updateButtons() {
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    const submitBtn = document.getElementById('submitBtn');

    if (prevBtn) prevBtn.style.display = currentQuestion > 0 ? 'block' : 'none';

    if (currentQuestion === questions.length - 1) {
      if (nextBtn) nextBtn.style.display = 'none';
      if (submitBtn) submitBtn.style.display = 'block';
    } else {
      if (nextBtn) nextBtn.style.display = 'block';
      if (submitBtn) submitBtn.style.display = 'none';
    }
  }

  function nextQuestion() {
    if (userAnswers[currentQuestion] === undefined) {
      alert('Merci de sélectionner une réponse');
      return;
    }

    if (currentQuestion < questions.length - 1) {
      currentQuestion++;
      displayQuestion(currentQuestion);
    }
  }

  function previousQuestion() {
    if (currentQuestion > 0) {
      currentQuestion--;
      displayQuestion(currentQuestion);
    }
  }

  function calculateResult() {
    if (userAnswers[currentQuestion] === undefined) {
      alert('Merci de répondre à la dernière question');
      return;
    }

    const score = userAnswers.reduce((sum, val) => sum + val, 0);
    const resultDiv = document.getElementById('result');
    if (!resultDiv) return;

    let resultHTML = '';

    if (score >= 15) {
      resultHTML = `
        <div style="background: linear-gradient(135deg, #e8f5e8 0%, #d4ebd4 100%); border-left: 5px solid #7db87d; padding: 25px; border-radius: 12px;">
          <h3 style="color: #5d7a5d; margin-top: 0; font-size: 1.3em; font-weight: 600;">🟢 Probabilité Élevée (Score: ${score}/24)</h3>
          <p style="line-height: 1.7; color: #4a4a4a; margin-bottom: 12px;"><strong>Vos symptômes sont fortement compatibles avec une grossesse précoce.</strong></p>
          <p style="line-height: 1.7; color: #4a4a4a; margin-bottom: 12px;">Vous cumulez plusieurs signes typiques d'une nidation réussie. Si vous n'avez pas encore testé et que vous êtes à 10+ jours post-ovulation, c'est le bon moment pour faire un test de grossesse urinaire.</p>
          <p style="line-height: 1.7; color: #4a4a4a; margin: 0;"><strong>⚠️ Important :</strong> Seul un test confirmera avec certitude. Ces symptômes peuvent aussi être liés à votre cycle naturel.</p>
        </div>
      `;
    } else if (score >= 8) {
      resultHTML = `
        <div style="background: linear-gradient(135deg, #fff8f0 0%, #fef5eb 100%); border-left: 5px solid #e8a05d; padding: 25px; border-radius: 12px;">
          <h3 style="color: #b87a40; margin-top: 0; font-size: 1.3em; font-weight: 600;">🟡 Probabilité Moyenne (Score: ${score}/24)</h3>
          <p style="line-height: 1.7; color: #4a4a4a; margin-bottom: 12px;"><strong>Certains signes sont présents, mais rien de concluant pour le moment.</strong></p>
          <p style="line-height: 1.7; color: #4a4a4a; margin-bottom: 12px;">Vos symptômes peuvent correspondre à une grossesse débutante MAIS aussi au syndrome prémenstruel classique. La progestérone (présente après chaque ovulation) provoque les mêmes sensations, enceinte ou pas.</p>
          <p style="line-height: 1.7; color: #4a4a4a; margin: 0;"><strong>⚠️ Le piège :</strong> Ces symptômes seuls ne permettent pas de conclure. Attendez encore quelques jours puis testez, ou attendez vos règles.</p>
        </div>
      `;
    } else {
      resultHTML = `
        <div style="background: linear-gradient(135deg, #fff5f8 0%, #ffeef4 100%); border-left: 5px solid #d97575; padding: 25px; border-radius: 12px;">
          <h3 style="color: #b85f5f; margin-top: 0; font-size: 1.3em; font-weight: 600;">🔴 Trop Tôt Ou Improbable (Score: ${score}/24)</h3>
          <p style="line-height: 1.7; color: #4a4a4a; margin-bottom: 12px;"><strong>Pas de signe clair de grossesse actuellement — ou c'est encore trop tôt.</strong></p>
          <p style="line-height: 1.7; color: #4a4a4a; margin-bottom: 12px;">Soit vous êtes encore dans la période où rien n'est détectable (moins de 6 jours post-ovulation), soit les symptômes ne concordent pas avec une grossesse précoce.</p>
          <p style="line-height: 1.7; color: #4a4a4a; margin: 0;"><strong>⚠️ Rappel :</strong> 75% des femmes enceintes ne ressentent RIEN au moment de la nidation. L'absence de symptômes ne signifie pas absence de grossesse. Testez au moment de votre retard de règles.</p>
        </div>
      `;
    }

    resultDiv.innerHTML = resultHTML;
    resultDiv.style.display = 'block';
    resultDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function initQuiz() {
    console.log('Quiz initialisé');

    const nextBtn = document.getElementById('nextBtn');
    const prevBtn = document.getElementById('prevBtn');
    const submitBtn = document.getElementById('submitBtn');

    if (nextBtn) nextBtn.addEventListener('click', nextQuestion);
    if (prevBtn) prevBtn.addEventListener('click', previousQuestion);
    if (submitBtn) submitBtn.addEventListener('click', calculateResult);

    displayQuestion(0);
  }

  initQuiz();
  console.log('✅ Quiz grossesse initialisé');
})();